// @flow
import { takeEvery, call, put } from 'redux-saga/effects';

import { getArrayResource } from '@redux/components/ApiRequest/actions';
import { pageReady } from '@redux/components/Page/actions';

import { FAQS } from '@routes';
import { mainApiUrl } from '@lib';
import { Router } from '@i18n';

import type { Action } from '../types';

import {
  FETCH_FAQ_CATEGORIES,
  FETCH_FAQ_CATEGORY_QUESTIONS,
  FETCH_FAQ_CATEGORY_QUESTIONS_FAILURE,
  FETCH_FAQ_CATEGORY_QUESTIONS_SUCCESS
} from './constants';

import {
  fetchFaqCategoriesSuccess,
  fetchFaqCategoriesFailure,
  fetchFaqCategoryQuestionsSuccess,
  fetchFaqCategoryQuestionsFailure
} from './actions';

export function* fetchFaqCategoriesFlow(): Generator<Function, void, void> {
  const url = `${mainApiUrl}/v1/faq_categories`;
  yield put(getArrayResource(url, fetchFaqCategoriesSuccess, fetchFaqCategoriesFailure));
}

export function* fetchFaqCategoryQuestionsFlow(action: Action): Generator<Function, void, void> {
  const { categorySlug, limit }: Action = action;

  if (!categorySlug) return;

  const url: string = `${mainApiUrl}/v1/faq_categories/${categorySlug}/faq_questions`;
  const params: {} = { per_page: limit };

  const successAction = yield call(fetchFaqCategoryQuestionsSuccess, categorySlug);
  const failureAction = yield call(fetchFaqCategoryQuestionsFailure, categorySlug);

  if (!successAction || !failureAction) return;

  yield put(getArrayResource(url, successAction, failureAction, { params }));
}


export function* fetchFaqCategoryQuestionsFailureFlow(
  action: Action
): Generator<Function, void, void> {
  const { error } = action;

  if (typeof window !== 'undefined' && error?.response?.status === 404) yield call(Router.pushRoute, FAQS);

  yield put(pageReady());
}

export function* fetchfaqCategoryQuestionsSuccessFlow(): Generator<Function, void, void> {
  yield put(pageReady());
}

export function* faqsFlow(action: Action): Generator<Function, void, void> {
  switch (action.type) {
    case FETCH_FAQ_CATEGORIES:
      yield call(fetchFaqCategoriesFlow, action);
      break;
    case FETCH_FAQ_CATEGORY_QUESTIONS_FAILURE:
      yield call(fetchFaqCategoryQuestionsFailureFlow, action);
      break;
    case FETCH_FAQ_CATEGORY_QUESTIONS:
      yield call(fetchFaqCategoryQuestionsFlow, action);
      break;
    case FETCH_FAQ_CATEGORY_QUESTIONS_SUCCESS:
      yield call(fetchfaqCategoryQuestionsSuccessFlow, action);
      break;
    default:
      break;
  }
}

function* faqsWatcher(): Generator<Function, void, void> {
  yield takeEvery(
    [
      FETCH_FAQ_CATEGORIES,
      FETCH_FAQ_CATEGORY_QUESTIONS,
      FETCH_FAQ_CATEGORY_QUESTIONS_FAILURE,
      FETCH_FAQ_CATEGORY_QUESTIONS_SUCCESS
    ],
    faqsFlow
  );
}

export default faqsWatcher;
